import { Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const CustomMoreActionTooltip = withStyles({
   tooltip: {
      '&.MuiTooltip-tooltip': {
         padding: 0,
         borderRadius: '6px',
         fontFamily: "'Montserrat', san-serif",
      },
   },
})(Tooltip);

const HolidaysTooltip = (props) => {
   const { t } = useTranslation();
   const language = useSelector((state) => state.languageR.language);

   return (
      <div className='w-full overflow-hidden'>
         <CustomMoreActionTooltip
            title={
               <div className='p-3'>
                  {props.noHoliday === true ? (
                     <p className='text-sm'>{t('common.no-holidays')}</p>
                  ) : (
                     <p className='text-sm'>
                        {language === 'en'
                           ? `${props.description} ${t('common.holiday').toLowerCase()}`
                           : `${t('common.holiday')} ${props.description}`}
                     </p>
                  )}
               </div>
            }
            placement='top'
            arrow
         >
            <div>{props.children}</div>
         </CustomMoreActionTooltip>
      </div>
   );
};

export default HolidaysTooltip;
